import React from 'react';
import faqs from '../Images/faqupdated2.png';
import '../styles/Details.css';

function Faqs() {
  return (
    <img src={faqs} alt="faqs" className='faqs-image' />
  );
}

export default Faqs;
